// Función para seleccionar una combinación aleatoria
export const selectRandomCombination = (arr) => {
    if (!arr || arr.length === 0) return [];
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
};